<ng-container *ngIf="!isLoading; else loadingFilterBar">
  <div class="filter-headline">
    <h2>Aktuelles –<br />bleiben Sie stets auf dem Laufenden.</h2>
    <h4>Bitte wählen Sie eine Kategorie:</h4>
  </div>
  <div class="filter-container">
    <hdi-filter
      [label]="'Alle'"
      [isSelected]="selectedFilter === 'Alle'"
      (clickEvent)="handleClick($event)"
    ></hdi-filter>
    <ng-container *ngIf="!caasFilters">
      <hdi-filter
        *ngFor="let filter of filters"
        [label]="filter | capitalize"
        [isSelected]="selectedFilter === filter"
        (clickEvent)="handleClick($event)"
      ></hdi-filter>
      <hdi-dropdown
        [type]="DropdownType.COMBOBOX_FILTER"
        [dropdownPlaceholder]="'Filter auswählen'"
        [itemList]="filtersMobile"
        (clickEvent)="handleClick($event)"
      ></hdi-dropdown>
    </ng-container>
    <ng-container *ngIf="caasFilters">
      <hdi-filter
        *ngFor="let filter of caasFilters"
        [label]="filter.filter | capitalize"
        [isSelected]="selectedFilterCaas?.filter === filter.filter"
        (clickEvent)="handleClick($event)"
      ></hdi-filter>
      <hdi-dropdown
        [type]="DropdownType.COMBOBOX_FILTER"
        [dropdownPlaceholder]="'Filter auswählen'"
        [itemList]="filtersMobile"
        (clickEvent)="handleClick($event)"
      ></hdi-dropdown>
    </ng-container>
  </div>
</ng-container>

<!-- Loading Placeholder -->
<ng-template #loadingFilterBar>
  <div class="filter-headline">
    <div class="h2-loader">
      <ngx-skeleton-loader
        [theme]="{
          width: '100%',
          height: '100%',
          'margin-bottom': '0',
        }"
      ></ngx-skeleton-loader>
    </div>
    <div class="h4-loader">
      <ngx-skeleton-loader
        [theme]="{
          width: '100%',
          height: '100%',
          'margin-bottom': '0',
        }"
      ></ngx-skeleton-loader>
    </div>
  </div>
  <div class="filter-container">
    <div class="filter-loader" *ngFor="let filter of [].constructor(4)">
      <ngx-skeleton-loader
        [theme]="{
          width: '100%',
          height: '100%',
          'margin-bottom': '0',
        }"
      ></ngx-skeleton-loader>
    </div>
    <div class="dropdown-loader">
      <ngx-skeleton-loader
        [theme]="{
          width: '100%',
          height: '100%',
          'margin-bottom': '0',
        }"
      ></ngx-skeleton-loader>
    </div>
  </div>
</ng-template>
